import { View } from "react-native";

import $ from "./GlassView.web.styles";
import type { GlassViewProps } from "./types";

const GlassView = ({ style, pointerEvents, children }: GlassViewProps) => (
  <View style={[$.fallback, style]} pointerEvents={pointerEvents}>
    {children}
  </View>
);

export default GlassView;
